export const isMobile = () =>
    /iphone|ipod|android|ie|blackberry|fennec/i.test(navigator.userAgent);

export const isString = (value) => typeof value === "string";

export const isIphone = () => /iphone|ipod/i.test(navigator.userAgent);
